/* globals require, USE_CSS_RESET */
import React, { Fragment } from 'react';
import {
  compose,
  defaultProps,
  lifecycle,
  setDisplayName,
  withProps,
} from 'recompose';
import DomainSuggestionTool from './ConnectedDomainSuggestionTool';
import {
  HeadingRoot,
  HeadingSection,
} from '@team-griffin/react-heading-section';
import { IntlProvider } from 'react-intl';
import { Content } from '@ux/typeface';
import { Container } from '@ux/grid';
import ModalRoutes from './ModalRoutes';
import container from '../scss/container.scss';
import { isTrue, nuller } from '../../crosscutting/capra';
import * as r from 'ramda';

const cssReset = (USE_CSS_RESET) ? require('../scss/main.scss') : null;

const shouldShow = r.propEq('show', true);

export const PureApp = r.ifElse(
  shouldShow,
  ({
    tlds,
    currency,
    theme,
    features,
    requiresContainer,
    negotiate,
    transferableTlds,
    backorderableTlds,
    negotiableTlds,
    basketFqdns,
    stickyOffset,
    legal,
    unspunTlds,
    initialFilters,
    includeTax,
    usePPE,
    displayPricing,
    messages,
    locale,
  }) => (
    <IntlProvider
      locale={locale}
      messages={messages}
    >
      <Fragment>
        <style>
          {cssReset}
          <If condition={requiresContainer}>
            {container}
          </If>
        </style>
        <div className="domain-suggestion-tool">
          <Container
            theme={theme}
            fluid={true}
          >
            <HeadingRoot>
              <HeadingSection>
                <Content
                  component="div"
                  theme={theme}
                >
                  <DomainSuggestionTool
                    features={features}
                    tlds={tlds}
                    transferableTlds={transferableTlds}
                    backorderableTlds={backorderableTlds}
                    negotiableTlds={negotiableTlds}
                    theme={theme}
                    currency={currency}
                    basketFqdns={basketFqdns}
                    stickyOffset={stickyOffset}
                    legal={legal}
                    unspunTlds={unspunTlds}
                    initialFilters={initialFilters}
                    includeTax={includeTax}
                    usePPE={usePPE}
                    displayPricing={displayPricing}
                  />

                  <ModalRoutes
                    theme={theme}
                    currency={currency}
                    negotiate={negotiate}
                  />
                </Content>
              </HeadingSection>
            </HeadingRoot>
          </Container>
        </div>
      </Fragment>
    </IntlProvider>
  ),
  nuller,
);

export const enhance = compose(
  setDisplayName('App'),
  defaultProps({
    requiresContainer: true,
  }),
  lifecycle({
    componentDidMount: function() {
      this.props.onSeed(
        this.props.config.query,
        this.props.config.brandId,
      );
    },
  }),
  withProps(({
    seeded,
    localeLoaded,
  }) => ({
    show: r.and(isTrue(seeded), isTrue(localeLoaded)),
  })),
);

export default enhance(PureApp);
